export const SESSION_IDLE_TIMEOUT_MS = 15 * 60 * 1000
export const SESSION_TIMEOUT_MESSAGE = 'Session Timeout'
export const SESSION_TIMEOUT_LOGIN_PATH = '/login?expired=true'
const SESSION_ACTIVITY_KEY = 'happometer_last_activity'
const ROSTER_SYNC_ACTIVE_KEY = 'happometer_roster_sync_active'
export const ROSTER_SYNC_ACTIVITY_EVENT = 'happometer-roster-sync-activity'
const ROSTER_SYNC_MAX_ACTIVE_MS = 2 * 60 * 60 * 1000

/** True while a Northstar roster sync is running — idle timeout is suppressed. */
export function isRosterSyncActive(now = Date.now()): boolean {
    try {
        const raw = localStorage.getItem(ROSTER_SYNC_ACTIVE_KEY)
        if (!raw) return false
        const startedAt = parseInt(raw, 10)
        if (!Number.isFinite(startedAt)) {
            localStorage.removeItem(ROSTER_SYNC_ACTIVE_KEY)
            return false
        }
        if (now - startedAt > ROSTER_SYNC_MAX_ACTIVE_MS) {
            localStorage.removeItem(ROSTER_SYNC_ACTIVE_KEY)
            return false
        }
        return true
    } catch {
        return false
    }
}

export function setRosterSyncActive(active: boolean): void {
    try {
        if (active) {
            localStorage.setItem(ROSTER_SYNC_ACTIVE_KEY, Date.now().toString())
            recordSessionActivity()
        } else {
            localStorage.removeItem(ROSTER_SYNC_ACTIVE_KEY)
        }
    } catch {
        /* ignore */
    }

    if (typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent(ROSTER_SYNC_ACTIVITY_EVENT, { detail: { active } }))
    }
}

export function shouldBypassIdleTimeout(): boolean {
    return isRosterSyncActive()
}

export function readSessionLastActivity(): number {
    try {
        const value = parseInt(localStorage.getItem(SESSION_ACTIVITY_KEY) || '0', 10)
        return Number.isFinite(value) ? value : 0
    } catch {
        return 0
    }
}

export function recordSessionActivity(): void {
    try {
        localStorage.setItem(SESSION_ACTIVITY_KEY, Date.now().toString())
    } catch {
        /* ignore */
    }
}

export function clearSessionActivity(): void {
    try {
        localStorage.removeItem(SESSION_ACTIVITY_KEY)
    } catch {
        /* ignore */
    }
}

export function isSessionIdleExpired(now = Date.now()): boolean {
    if (shouldBypassIdleTimeout()) return false
    const last = readSessionLastActivity()
    if (last <= 0) return false
    return now - last >= SESSION_IDLE_TIMEOUT_MS
}

/** Staff session is expired when idle limit is exceeded or login timestamp is too old. */
export function isStaffSessionExpired(sessionTs: number, now = Date.now()): boolean {
    if (shouldBypassIdleTimeout()) return false
    const lastActivity = readSessionLastActivity()
    if (lastActivity > 0) {
        return now - lastActivity >= SESSION_IDLE_TIMEOUT_MS
    }
    if (!Number.isFinite(sessionTs) || sessionTs <= 0) return false
    return now - sessionTs >= SESSION_IDLE_TIMEOUT_MS
}
